(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("ELEMENT"));
	else if(typeof define === 'function' && define.amd)
		define("HJPdfSignLocationPlugin", ["ELEMENT"], factory);
	else if(typeof exports === 'object')
		exports["HJPdfSignLocationPlugin"] = factory(require("ELEMENT"));
	else
		root["HJPdfSignLocationPlugin"] = factory(root["ELEMENT"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__6__) {
return 